import KlarnaLandingPage from './KlarnaLandingPage'

export default KlarnaLandingPage
